import React, { createContext, useContext } from 'react'
import { useAsyncResource } from '../hooks/useAsyncResource'
import { getNews, parseWordpressRes } from '../services/cms'
import { localNewsData } from 'data/news'

const NewsContext = createContext(null)

export function NewsProvider ({ children }) {
  const newsResource = useAsyncResource(async (signal) => {
    try {
      return await getNews({ signal })
    } catch {
      return parseWordpressRes(localNewsData)
    }
  })

  const value = {
    news: newsResource.data,
    isNewsLoading: newsResource.loading,
    newsError: newsResource.error,
    fetchNews: newsResource.load
  }

  return <NewsContext.Provider value={value}>{children}</NewsContext.Provider>
}

export const useNews = () => {
  const ctx = useContext(NewsContext)
  if (!ctx) throw new Error('useNews must be used within <NewsProvider>')
  return ctx
}
